<script setup lang="ts">
import { getChain, type ChainTag } from "@umi/shared/chains";


const props = withDefaults(defineProps<{
  chainTag?: ChainTag
  value: string,
  externalIcon?: boolean,
  addressClass?: string,
  mode?: "ellipsis" | "slice",
  ellipsisCount?: number,
  noClipboard?: boolean,
  type?: "address" | "tx",
}>(), {
  noClipboard: false,
  externalIcon: true,
  mode: "ellipsis",
  type: "address",
  ellipsisCount: 5,
});

const chain = computed(() => {
  if (!props.chainTag) return;
  return getChain(props.chainTag);
});
</script>

<template>

  <span
    class="
    relative
    group/address
    flex items-center">
    <a
      class="
        flex items-center
        font-mono text-xs
        hover:underline text-black dark:text-white dark:font-medium"
      :class="addressClass"
      :href="chain?.explorerLink(type, value)"
      target="_blank">
      <template v-if="mode === 'ellipsis'">{{ ellipsis(value, ellipsisCount) }}</template>
      <template v-else>{{ value.slice(-ellipsisCount) }}</template>
      <UIcon
        v-if="externalIcon"
        name="i-tabler-external-link"
        class="ml-1 hidden sm:flex sm:opacity-0 group-hover/address:opacity-100 transition-opacity" />
    </a>
    <GenericClipboard
      v-if="!noClipboard"
      :text="value"
      class="ml-2 sm:ml-1 opacity-100 sm:opacity-0 group-hover/address:opacity-100 transition-opacity" />
  </span>
</template>
